import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, MessageCircle, Shield, FileText, Megaphone, Users, MapPin, Phone } from 'lucide-react';
import { footerLinks } from '../mock';
import NewsletterSignup from './NewsletterSignup';

const FooterDirectory = () => {
  return (
    <>
      <footer className="bg-gray-50 border-t border-gray-200 mt-12">
        <div className="max-w-[1400px] mx-auto px-4 py-8">
          {/* Newsletter Signup */}
          <div className="mb-8">
            <NewsletterSignup />
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
            {Object.entries(footerLinks).map(([category, links], index) => (
              <div key={index}>
                <h4 className="text-sm font-bold text-gray-800 mb-3">{category}</h4>
                <ul className="space-y-2">
                  {links.map((link, linkIndex) => (
                    <li key={linkIndex}>
                      <a
                        href={link.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-xs text-gray-600 hover:text-green-600 hover:underline transition-colors"
                      >
                        {link.name}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          {/* Contact Us & Advertise Section */}
          <div className="border-t border-gray-200 mt-8 pt-6">
            <div className="flex flex-col md:flex-row items-center justify-center gap-4 mb-6">
              <div className="flex items-center gap-2 text-gray-700">
                <MessageCircle className="w-5 h-5 text-green-600" />
                <span className="text-sm font-medium">Tienes preguntas o sugerencias?</span>
              </div>
              <div className="flex flex-wrap items-center justify-center gap-3">
                <Link
                  to="/contacto"
                  className="flex items-center gap-2 px-6 py-3 bg-green-600 text-white font-semibold rounded-lg hover:bg-green-700 transition-all duration-300 shadow-md hover:shadow-lg"
                >
                  <Mail className="w-5 h-5" />
                  Contactanos
                </Link>
                <Link
                  to="/anunciate"
                  className="flex items-center gap-2 px-6 py-3 bg-orange-500 text-white font-semibold rounded-lg hover:bg-orange-600 transition-all duration-300 shadow-md hover:shadow-lg"
                >
                  <Megaphone className="w-5 h-5" />
                  Anúnciate
                </Link>
              </div>
            </div>
            
            {/* Legal Links - Prominent dedicated bar */}
            <div className="bg-white border border-gray-200 rounded-xl p-4 mb-6">
              <p className="text-xs text-gray-500 text-center mb-3 font-semibold uppercase tracking-wider">Informacion Legal</p>
              <div className="flex flex-wrap items-center justify-center gap-4 md:gap-8">
                <Link
                  to="/privacidad"
                  className="flex items-center gap-1.5 text-sm font-semibold text-gray-800 hover:text-green-600 transition-colors bg-gray-50 px-4 py-2 rounded-lg"
                >
                  <Shield className="w-4 h-4 text-green-600" />
                  Aviso de Privacidad
                </Link>
                <Link
                  to="/terminos"
                  className="flex items-center gap-1.5 text-sm font-semibold text-gray-800 hover:text-green-600 transition-colors bg-gray-50 px-4 py-2 rounded-lg"
                >
                  <FileText className="w-4 h-4 text-green-600" />
                  Terminos de Servicio
                </Link>
                <Link
                  to="/nosotros"
                  className="flex items-center gap-1.5 text-sm font-semibold text-gray-800 hover:text-green-600 transition-colors bg-gray-50 px-4 py-2 rounded-lg"
                >
                  <Users className="w-4 h-4 text-green-600" />
                  Sobre Nosotros
                </Link>
                <Link
                  to="/contacto"
                  className="flex items-center gap-1.5 text-sm font-semibold text-gray-800 hover:text-green-600 transition-colors bg-gray-50 px-4 py-2 rounded-lg"
                >
                  <Mail className="w-4 h-4 text-green-600" />
                  Contacto
                </Link>
              </div>
            </div>
            
            <div className="text-center">
              <p className="text-xs text-gray-500">
                © {new Date().getFullYear()}{' '}
                <Link 
                  to="/admin" 
                  className="text-gray-500 hover:text-gray-500 cursor-default"
                  title=""
                >
                  Portal <span className="italic" style={{ color: '#006847' }}>Méxi</span><span className="italic" style={{ color: '#CE1126' }}>co</span>
                </Link>
                . Tu punto de partida en internet. Hecho en México.
              </p>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default FooterDirectory;